import { get } from './api.service'

const KvkService = {
	getKvkSearch(params: any) {
		return get('/kvk/search', params)
	},
	getKvkDetail(kvkId: string, params: any) {
		return get(`/kvk/detail/${kvkId}`, params)
	},
}

export default KvkService
